module.exports = __webpack_public_path__ + "img/tax-inspection.ff83fa14.svg";